import { makeEntityScaffold } from '@classpass/saga-tools';

export const getCountries = makeEntityScaffold('SAGA.API.GET_COUNTRIES', client =>
  client.countries.get().then(data => data.countries)
);
